module.exports = __webpack_public_path__ + "img/lesson_02.f42b97bd.jpg";